import React, { useEffect, useState } from "react";
import { auth, db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import DashboardLayout from "../../layouts/DashboardLayout";
import { EmailAuthProvider, reauthenticateWithCredential, updateEmail, updatePassword } from "firebase/auth";
import { sendEmailVerification } from "firebase/auth";


const Profile = () => {
    const user = auth.currentUser;
    const [profile, setProfile] = useState({
        voornaam: "",
        achternaam: "",
        bedrijf: "",
        telefoon: "",
        profielfotoUrl: "",
        email: "",
        secundairEmail: ""
    });

    const [file, setFile] = useState(null);
    const [wachtwoord, setWachtwoord] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");

    useEffect(() => {
        const fetchProfile = async () => {
            const ref = doc(db, "users", user.uid);
            const snap = await getDoc(ref);
            if (snap.exists()) {
                const data = snap.data();
                setProfile(data);
                setNewEmail(data.email);
            }
        };

        if (user) {
            fetchProfile();
        }
    }, [user]);

    const uploadToCloudinary = async (file) => {
        const data = new FormData();
        data.append("file", file);
        data.append("upload_preset", "Osm-calendar");
        data.append("cloud_name", "ddhiqnuqn");

        const res = await fetch("https://api.cloudinary.com/v1_1/ddhiqnuqn/image/upload", {
            method: "POST",
            body: data,
        });

        const json = await res.json();
        return json.secure_url;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let updatedProfile = { ...profile };

        if (file) {
            try {
                const url = await uploadToCloudinary(file);
                updatedProfile.profielfotoUrl = url;
            } catch (err) {
                console.error("Upload mislukt:", err);
                return alert("Uploaden mislukt.");
            }
        }

        await setDoc(doc(db, "users", user.uid), updatedProfile);
        alert("Profiel opgeslagen ✅");
    };

    const handleAccountUpdate = async () => {
        try {
            // Email wijzigen
            if (newEmail && newEmail !== user.email) {
                await updateEmail(user, newEmail);
                await sendEmailVerification(user);
                alert("E-mailadres bijgewerkt. Verifieer je nieuwe e-mail via de link die je hebt ontvangen.");

                // Verzend ook naar secundair e-mailadres
                if (profile.secundairEmail) {
                    await fetch("/send-secondary-verification", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            to: profile.secundairEmail,
                            from: newEmail,
                            name: `${profile.voornaam} ${profile.achternaam}`,
                        }),
                    });
                    alert("Ook verzonden naar secundair e-mailadres.");
                }
            }

            // Wachtwoord wijzigen
            if (wachtwoord) {
                await user.updatePassword(wachtwoord);
                alert("Wachtwoord bijgewerkt ✅");
                setWachtwoord("");
            }
        } catch (err) {
            console.error(err);
            if (err.code === "auth/requires-recent-login") {
                alert("Om je e-mailadres of wachtwoord te wijzigen moet je opnieuw inloggen.");
            } else {
                alert("Bijwerken mislukt. Mogelijk moet je opnieuw inloggen.");
            }
        }
    };

    return (
        <DashboardLayout>
            <div className="max-w-xl mx-auto bg-white p-6 rounded shadow">
                <h2 className="text-2xl font-semibold mb-4">Mijn profiel</h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Profielfoto */}
                    <div>
                        <label className="block text-sm font-medium mb-1">Profielfoto</label>
                        {profile.profielfotoUrl && (
                            <img
                                src={profile.profielfotoUrl}
                                alt="Profielfoto"
                                className="w-20 h-20 rounded-full object-cover mb-2"
                            />
                        )}
                        <input type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
                    </div>

                    {/* Naam */}
                    <div>
                        <label className="block text-sm font-medium mb-1">Naam</label>
                        <div className="flex gap-4">
                            <input
                                type="text"
                                className="w-1/2 border rounded px-3 py-2"
                                placeholder="Voornaam"
                                value={profile.voornaam || ""}
                                onChange={(e) => setProfile({ ...profile, voornaam: e.target.value })}
                            />
                            <input
                                type="text"
                                className="w-1/2 border rounded px-3 py-2"
                                placeholder="Achternaam"
                                value={profile.achternaam || ""}
                                onChange={(e) => setProfile({ ...profile, achternaam: e.target.value })}
                            />
                        </div>
                    </div>

                    {/* Bedrijf */}
                    <div>
                        <label className="block text-sm font-medium mb-1">Bedrijf</label>
                        <input
                            type="text"
                            className="w-full border rounded px-3 py-2"
                            value={profile.bedrijf}
                            onChange={(e) => setProfile({ ...profile, bedrijf: e.target.value })}
                        />
                    </div>

                    {/* Telefoonnummer */}
                    <div>
                        <label className="block text-sm font-medium mb-1">Telefoonnummer</label>
                        <input
                            type="text"
                            className="w-full border rounded px-3 py-2"
                            value={profile.telefoon}
                            onChange={(e) => setProfile({ ...profile, telefoon: e.target.value })}
                        />
                    </div>
                    {/* Primair e-mailadres */}
                    <div>
                        <label className="block text-sm font-medium mb-1">Primair e-mailadres</label>
                        <input
                            type="email"
                            className="w-full border rounded px-3 py-2"
                            value={profile.email || ""}
                            onChange={(e) => setProfile({ ...profile, email: e.target.value })}
                            placeholder="Bijv. info@bedrijf.nl"
                        />
                    </div>
                    {/* Secundair e-mailadres */}
                    <div>
                        <label className="block text-sm font-medium mb-1">Secundair e-mailadres (optioneel)</label>
                        <input
                            type="email"
                            className="w-full border rounded px-3 py-2"
                            value={profile.secundairEmail || ""}
                            onChange={(e) => setProfile({ ...profile, secundairEmail: e.target.value })}
                            placeholder="Bijv. info@bedrijf.nl"
                        />
                    </div>

                    <button
                        type="submit"
                        className="bg-[#175151] text-white px-4 py-2 rounded hover:bg-[#148c87] transition"
                    >
                        Profiel opslaan
                    </button>
                </form>

                {/* 🔐 Accountinstellingen */}
                <div className="pt-6 mt-6 border-t">
                    <h3 className="text-lg font-semibold mb-4">Accountinstellingen</h3>

                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">Nieuw e-mailadres</label>
                            <input
                                type="email"
                                className="w-full border rounded px-3 py-2"
                                value={newEmail}
                                onChange={(e) => setNewEmail(e.target.value)}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Nieuw wachtwoord</label>
                            <input
                                type="password"
                                className="w-full border rounded px-3 py-2"
                                value={wachtwoord}
                                onChange={(e) => setWachtwoord(e.target.value)}
                                placeholder="Laat leeg als je niet wilt wijzigen"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Huidig wachtwoord</label>
                            <input
                                type="password"
                                className="w-full border rounded px-3 py-2"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                required
                            />
                        </div>

                        <button
                            type="button"
                            onClick={handleAccountUpdate}
                            className="bg-[#175151] text-white px-4 py-2 rounded hover:bg-[#148c87] transition"
                        >
                            Account bijwerken
                        </button>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default Profile;
